export default {
	InvitationCode: "招待コード",
	CreditScore: "クレジットスコア",
	MyFinancial: {
		title: "私の財務",
		menu: ["預金", "引き出し", "取引"]
	},
	MyDetail: {
		title: "私の詳細",
		menu: ["個人情報", "支払い方法"]
	},
	Other: {
		title: "その他",
		menu: ["お問い合わせ", "通知", "言語を変更する"]
	},
	Amount: ["ウォレットの残高", "凍結残高", "今日の収益"],
	Logout: {
		title: "ログアウト",
		content: "本当にログアウトしますか？"
	}
};
